import { Billing } from 'src/app/dice/_models/dice-quote';
import { AddressType, ThirdPartyNames } from 'src/app/_common/_enum/module.enum';

export class Submission {
    selectedStep: string;
    selectedNiche = null;
    selectedProducer = null;
    submissionData: any = new SubmissionForm();
    
    isExistingAccount: boolean = null;
    isBusinessAddressVerified: boolean = false;
    isMailingAddressVerified: boolean = false;
    isBillingAddressVerified: boolean = false;
    
    isMailingSameAsInsured: boolean = false;
    isBillingSameAsMailing: boolean = false;

    allCoverages = [];

    underwriter:any = "";
    underwriters = [];

    allowAttachments: boolean = true;
}

export class SubmissionForm{
    thirdPartyName: string = ThirdPartyNames.DNB;
    thirdPartyKey: string = "";
    searchState: string = "";
    accountNumber: number = 0;
    accountName: string = "";
    accountDBAName: string = "";
    accountLegalEntity: any = "";
    accountFein: string = "";
    accountWebsite: string = "";
    accountPhoneNumber: string = "";
    accountIndicator: number = 0; //0 = Block, 1 = New, 2 = CreateAccount, 3 = ExistingAccount, 4 = Reffered
    accountKey: string = "";
    producerCode: string = "";
    producerName: string = "";
    niche: string = "";
    isMailingOrBillingSameAsInsured: number = 0; //0 = both are same as insured, 1 = mailing same as insured, 2 = billing same as mailing, 3 = mailing and billing both are different
    addresses = [
       new BusinessAddress(),
       new MailingAddress(),
       new BillingAddress()
    ];
    primaryContactNotProvided: boolean = true;
    contact = {};
    policyEffectiveDate: string = "";
    policyExpirationDate: string = "";
    policyNeedByDate: string = "";
    riskState: string = "";
    coverages = [];
    sicCodes = [];
    naicsCodes = [];
    underwriter = "";
    notes = "";
    submittedDate: string = new Date().toDateString();
    submittedBy: string = "";
    submittedEmail: string = "";
    attachments = [];
}

export class LocationObject{
    addressType : string = "";
    careof: string = "";
    addressLine1: string = "";
    addressLine2: string = "";
    city: string = "";
    state: string = "";
    zip: string = "";
    country: string = "";
    county: string = "";
    verified: string = "";
}

export class BusinessAddress extends LocationObject{
    addressType : string = AddressType.Business;
}
export class MailingAddress extends LocationObject{
    addressType : string = AddressType.Mailing;
}
export class BillingAddress extends LocationObject{
    addressType : string = AddressType.Billing;
}

export class ContactObject{
    firstName:string = "";
    lastName:string = "";
    roleName: string = "primary";
    email: string = "";
    phone: string = "";
}

export class CoveragesObject {
    lobName: string = "";
    productName: string = "";
    productDescription: string = null;
    customerSegment: string = "";
    niche: string = "";
    businessEntity: string = "";
    writingCompany: string = "";
    indicator: string = "";
    underwriters: any = [];
    isSelected: boolean = false;
}

export class AttachmentObject {
    documentType?: string = "";
    fileType?: string ="";
    fileName?: string ="";
    contentStream?: string = "";
}



export class SubmissionMethod{
    getBusinessAddress(_submission:Submission){
        return _submission.submissionData.addresses[0];
    }
    
    getMailingAddress(_submission:Submission){
        if(!_submission.isMailingSameAsInsured && _submission.submissionData.addresses.length > 1)
            return _submission.submissionData.addresses.find(_address=> {return _address.addressType === AddressType.Mailing});
        else
            return null;
    }
    
    getBillingAddress(_submission:Submission){
        if(!_submission.isBillingSameAsMailing && _submission.submissionData.addresses.length > 1)
            return _submission.submissionData.addresses.find(_address=> {return _address.addressType === AddressType.Billing});
        else
            return null;
    }
}